<spb-header class="header"></spb-header>
<main id="main-content" class="spb-holder mat-typography">
  <h1 class="title">Sparbanken Syd - Räkna på ditt boende</h1>
  <section class="object-info" aria-label="Objektinformation">
    <spb-object-info></spb-object-info>
  </section>
  <div class="calc-holder">
    <section aria-label="Uppgifter för beräkning">
      <spb-input></spb-input>
    </section>
    <section aria-label="Resultat av beräkning">
      <spb-calculation></spb-calculation>
    </section>
  </div>
  <nav class="button-holder">
    <div class="button">
      <a [href]="calculatorUrl + '?' + calculatorQuery" spbAccessibleLink>
        Räkna på ditt boende</a>
    </div>
    <div class="button">
      <a
        [href]="'https://www.sparbankensyd.se/sv/privat/lana/bolan/lanelofte' + utmTags"
        spbAccessibleLink>Ansök om lånelöfte</a>
    </div>
    <div class="button">
      <a
        [href]="'https://www.sparbankensyd.se/privat/lana/bolan/ansokan-bolan' + utmTags"
        spbAccessibleLink>Ansök om bolån</a>
    </div>
  </nav>
  <aside class="disclaimer">
    @for (p of disclaimerText; track $index) {
      <p>{{ p }}</p>
    }
  </aside>
</main>
<div class="spb-filler"></div>
<footer>
  <spb-footer [license]="true" [version]="version"
              [copyrightYears]="copyrightYears"
  ></spb-footer>
</footer>
